import React, { useEffect, useState } from "react";
import {
  Typography,
  Paper,
  Box,
  Chip,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import LoadingButton from "@mui/lab/LoadingButton";
import Textfield from "../shared/textfield";
import { useAuth } from "../../contexts/AuthContext";
import { getApiUrl } from "../../services/api_service"
import { Redirect } from 'react-router-dom';
import { blackcolor, button, pcolor, rcolor, whitecolor } from "../../style2";


const paperSx = { padding: 3, margin: "auto" };
const mainTitleSx = { fontWeight: "bold", fontSize: 24, margin: "auto", color: pcolor };
const buttonInvertedSx = { width: 100, height: 30, background: "#FFFFFF", border: `1px solid ${rcolor}`, boxSizing: "border-box", borderRadius: 9, textTransform: "unset", color: rcolor, "&:hover": { color: "#FFFFFF", background: rcolor } };
const wrongTextSx = { color: rcolor, fontSize: 13 };

// const button = {
//   width: 140,
//   height: 40,
//   background: rcolor,
//   border: `1px solid ${rcolor}`,
//   boxSizing: "border-box",
//   borderRadius: 2,
//   textTransform: "unset",
//   color: whitecolor,
//   "&:hover": {
//     color: blackcolor,
//     background: rcolor,
//   },
// };

function useWindowSize() {
  const [size, setSize] = useState([window.innerHeight, window.innerWidth]);

  useEffect(() => {
    const handleResize = () => {
      setSize([window.innerHeight, window.innerWidth]);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return size;
}


export default function NewLoginForm() {
  let auth = useAuth();
  //const [height, width] = useWindowSize();
  const [apiStatus, setApiStatus] = useState({
    loading: false,
    success: false,
          error: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  //const [otp, setOtp] = useState([]);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  // const validationSchema = Yup.object({
  //   email: Yup.string().email("Invalid email format").required("Required"),
  //   password: Yup.string().required("Required"),
  // });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: (values) => {
      handleGenerateOTP(values);
    }
  });

  const handleGenerateOTP = async () => {
    if (formik.values.email === null || formik.values.email === "") {
      setError("Email is missing.");
      return;
    }
    setLoading(true);
    setError("");

    try {
      const response = await fetch(getApiUrl() + process.env.REACT_APP_GET_OTP + "?email=" + encodeURIComponent(formik.values.email), {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        setError(response.statusText);
        response.json().then(data => {
          //console.log(data);
        })
          .catch(err => {
            console.log(err);
            setError("Unable to process request. " + err);
          });

      }
      else {
        setShouldRedirect(true);
      }
    } catch (error) {
      setError(error.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (<>
    <Box pt={1} sx={{ maxWidth: "70%", margin: "0 auto", marginTop: "5px" }}>
      <Typography sx={{ color: pcolor, textAlign: "center", fontSize: "1.7rem", fontWeight: "bold", marginTop:3, marginBottom:3}} >Driving efficiency and productivity for clinical teams</Typography>
      <Box sx={{ textAlign: "center", paddingBottom: 2 }}>
        <Chip label="Empowering clinicians" variant="outlined" sx={{ background: whitecolor, color: pcolor, marginRight: 2 }} />
        <Chip label="Saving time" variant="outlined" sx={{ background: whitecolor, color: pcolor, marginRight: 2 }} />
        <Chip label="Actionable data" variant="outlined" sx={{ background: whitecolor, color: pcolor, marginRight: 2 }} />
        <Chip label="Care coordination" variant="outlined" sx={{ background: whitecolor, color: pcolor, marginRight: 2 }} />
        <Chip label="Enhancing proactive care " variant="outlined" sx={{ background: whitecolor, color: pcolor }} />
      </Box>
      <Paper sx={paperSx}>
        <Box pb={2} sx={{ maxWidth: "65%", margin: "0 auto" }}>
          <form onSubmit={formik.handleSubmit}>
            <Box>
              <Typography sx={{ ...mainTitleSx, textAlign: "center" }}>Sign In</Typography>
              <Box mt={1} />
              <Box item xs={12}>
                <Textfield title={"Email"} id={"email"} required={true}
                  value={formik.values.email} name={"email"} placeholder={"Your email"} onChange={formik.handleChange}
                  errorBoolean={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  maxCharacterLimit={100}
                />
              </Box>
              <Box m={1} />
              {error != "" ? <Typography sx={wrongTextSx}>{error}</Typography> : null}
              {auth.loginStatus !== 200 && (
                <Typography sx={wrongTextSx}>
                  Wrong email.
                </Typography>
              )}
              <Box m={5} />
              <Box item xs={12} align="center">
                <LoadingButton loading={apiStatus.loading || auth.loginLoading || loading}
                  sx={button} type="submit">
                  Generate OTP
                </LoadingButton>
                <Typography style={{marginTop:"20px"}}>OTP sent to your registered mobile number and email.</Typography>  
              </Box>
            </Box>
          </form>
        </Box>
      </Paper>
      {shouldRedirect ? <Redirect to={`/validateotp/${formik.values.email}`} /> : null}
    </Box>
  </>
  );
}
